export const CTRADER_OAUTH_POPUP_MESSAGE_TYPE = "tessera:ctrader-oauth" as const;

export type CtraderOAuthPopupMessage = {
  type: typeof CTRADER_OAUTH_POPUP_MESSAGE_TYPE;
  status: "success" | "error" | "cancelled";
  accountCode?: string;
  message?: string;
};

const CTRADER_OAUTH_POPUP_NAME = "tessera_ctrader_oauth";

/** Centered OAuth window sized for broker login, not full-screen. */
export function openCtraderOAuthPopup(authorizeUrl: string): Window | null {
  if (typeof window === "undefined") return null;

  const width = 520;
  const height = 680;
  const dualScreenLeft = window.screenLeft ?? window.screenX ?? 0;
  const dualScreenTop = window.screenTop ?? window.screenY ?? 0;
  const viewportWidth = window.outerWidth || window.innerWidth;
  const viewportHeight = window.outerHeight || window.innerHeight;
  const left = Math.max(0, dualScreenLeft + (viewportWidth - width) / 2);
  const top = Math.max(0, dualScreenTop + (viewportHeight - height) / 2);

  const features = [
    "popup=yes",
    `width=${width}`,
    `height=${height}`,
    `left=${Math.round(left)}`,
    `top=${Math.round(top)}`,
    "resizable=yes",
    "scrollbars=yes",
    "noopener=no",
    "noreferrer=no",
  ].join(",");

  return window.open(authorizeUrl, CTRADER_OAUTH_POPUP_NAME, features);
}

export function isCtraderOAuthPopupMessage(data: unknown): data is CtraderOAuthPopupMessage {
  if (!data || typeof data !== "object") return false;
  const record = data as Record<string, unknown>;
  return (
    record.type === CTRADER_OAUTH_POPUP_MESSAGE_TYPE &&
    (record.status === "success" || record.status === "error" || record.status === "cancelled")
  );
}

export function notifyCtraderOAuthOpener(message: CtraderOAuthPopupMessage): boolean {
  if (typeof window === "undefined" || !window.opener || window.opener.closed) {
    return false;
  }
  window.opener.postMessage(message, window.location.origin);
  window.close();
  return true;
}

export function isCtraderOAuthPopupContext(): boolean {
  return typeof window !== "undefined" && Boolean(window.opener) && !window.opener.closed;
}
